import ContinuePage from "@components/ContinuePage"

export default function HomeWhyHomeProfilePage() {
  return <ContinuePage emoji="🏠" translationKey="homeWhyHomeProfile" />
}
